<template>
  <div class="sku-tips" v-show="text * 1">
    <span>返{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'skuRewardsTipsOrder',
  props: ['text']
}
</script>

<style lang="less" scoped>
  .sku-tips {
    display: flex;
    font-size: @fz20;
    color: @price;
    span {
      padding: 0 0.1rem;
      height: 0.38rem;
      background-color: #FFEAEF;
      border-radius: 30px;
      .flex-center;
    }
  }
</style>
